export enum ProductTypeEnum {
    AUCTION = 100
}
